import axios from "./api";
class GeneralTestService {
  getAll() {
    return axios.get(`/generalTests`);
  }
  getByTraining(trainingId) {
    return axios.get(`/public/generalTests/${trainingId}`);
  }
  get(id) {
    return axios.get(`/generalTests/${id}`);
  }
  create(data) {
    return axios.post(`/generalTests`, data);
  }
  update(id, data) {
    return axios.put(`/generalTests/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/generalTests/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new GeneralTestService();
